import LimitedScope from "../components/AdvisorAgreement/LimitedScope";
import styled from "styled-components";
import theme from "../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  signAdvisoryAgreement,
  getNewDashboardInformation,
} from "../redux/actions";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import { SET_LOADING } from "../redux/action-types";
import HeaderWithoutLogin from "../components/HeaderWithoutLogin";

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 150px;

  @media (max-width: 480px) {
    padding: 30px 20px;
  }

  .limitedScopeContainer {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .signAcceptContainer {
    max-width: 800px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: flex-start;
    }

    .signContainer {
      width: 100%;
      display: flex;
      flex-direction: column;
      & label {
        width: 250px;
        font-size: 16px;
        border-top: 1px solid #6ac7dd;
        padding-bottom: 5px;
        margin: 0;
        padding-top: 5px;
        cursor: pointer;

        @media (max-width: 480px) {
          width: 100%;
        }
      }

      & input {
        font-family: Lobster;
        font-size: 24px;
        background-color: inherit;
      }

      & p {
        color: #ff0000;
        font-size: 12px;
        margin-left: 100px;
        position: absolute;
        display: ${(props) => (props.isInvalid ? "block" : "none")};
        @media (max-width: 480px) {
          left: 120px;
        }
      }
    }

    .acceptButtonContainer {
      @media (max-width: 480px) {
        margin-top: 30px;
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-right: 20px;
        right: 0px;
      }
      & button {
        font-weight: 700;
        font-size: 14px;
        border-radius: 4px;
        border: none;
        height: 50px;
        width: 120px;
        background-color: ${theme.colors.primaryStrong2X};
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
`;

const ArrowRight = styled(FontAwesomeIcon)`
  margin-left: 10px;
  font-size: 18px;
`;

const AdvisorAgreement = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const blankFields = {
    signature: "",
  };
  const [formData, setFormData] = useState(blankFields);
  const [isInvalid, setIsIvalid] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [btnIsClicked, setBtnIsClicked] = useState(false);
  const { newDashboardData, loading } = useSelector((state) => state.user);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
    if (!btnIsClicked) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [btnIsClicked, dispatch, loading]);

  const hanldeAcceptClick = async (event) => {
    event.preventDefault();
    if (formData.signature === "") {
      setIsIvalid(true);
    } else {
      setBtnIsClicked(true);
      const isSigned = await dispatch(
        signAdvisoryAgreement(formData.signature)
      );
      dispatch(getNewDashboardInformation());
      dispatch({ type: SET_LOADING, payload: true });
      //history.push("/strategy-screen");
      if (isSigned.id) {
        if (newDashboardData?.length <= 0) {
          history.push("/goal-picker");
        } else {
          history.push("/strategy-screen");
        }
      } else {
        dispatch({ type: SET_LOADING, payload: false });
      }
    }
  };

  const onChange = (event) => {
    setIsIvalid(false);
    setFormData({ ...formData, [event.target.id]: event.target.value });
  };

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      <HeaderWithoutLogin
        isHomeClickable={false}
        isLogOutButtonVisible={true}
      />
      <Wrapper isInvalid={isInvalid}>
        <div className="limitedScopeContainer">
          <LimitedScope />
        </div>
        <div className="signAcceptContainer">
          <div className="signContainer">
            <input
              id="signature"
              type="text"
              placeholder="Sign Here"
              autoComplete="off"
              onChange={onChange}
              value={formData.signature}
            />
            <label htmlFor="signature">Signature*</label>
            <p>You must sign the document</p>
          </div>
          <div className="acceptButtonContainer">
            <button onClick={hanldeAcceptClick} disabled={isInvalid}>
              ACCEPT
              <ArrowRight icon={faAngleRight} />
            </button>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default AdvisorAgreement;
